export default __webpack_public_path__ + "static/media/cif-tw.3768098c.svg";